// extracted by mini-css-extract-plugin
export var actionButton = "_ka-0";
export var actionMenuContainer = "_ka-i";
export var bubble = "_ka-2";
export var bubbleActionMenu = "_ka-j";
export var bubbleContext = "_ka-6";
export var bubbleItems = "_ka-7";
export var customer = "_ka-3";
export var divider = "_ka-8";
export var fileList = "_ka-9";
export var hiddenComment = "_ka-o";
export var infoAbove = "_ka-a";
export var internal = "_ka-4";
export var lightActionButton = "_ka-1";
export var link = "_ka-b";
export var merchant = "_ka-5";
export var message = "_ka-c";
export var profilePicture = "_ka-e";
export var quillToolbarContainer = "_ka-f";
export var senderDate = "_ka-g";
export var senderDateCustomer = "_ka-h";
export var senderName = "_ka-d";
export var time = "_ka-k";
export var uploadedImage = "_ka-l";
export var username = "_ka-m";
export var xsmall = "_ka-n";